import { render } from "./notification-detail.vue?vue&type=template&id=7b8c3cc5&scoped=true&ts=true&lang=pug"
import script from "./notification-detail.vue?vue&type=script&lang=ts"
export * from "./notification-detail.vue?vue&type=script&lang=ts"

import "./notification-detail.vue?vue&type=style&index=0&id=7b8c3cc5&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b8c3cc5"]])

export default __exports__